/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Form, Image, message } from "antd";
import { UserApi } from "api/user";
import WarningIcon from "assets/common/Symbol-warning.png";
import InputCustom from "components/common/InputCustom";
import MDrawer from "components/mobile/MDrawer";
import { userPath } from "constants/path";
import { ResponseCode } from "constants/response";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { selectUsername } from "store/auth";
import { selectProfile, updateChangepassword } from "store/user";
import { ApiResponse } from "types/api";
import * as yup from "yup";

interface PasswordWithdrawType {
  password: string;
  confirm_password: string;
}

const schema = yup.object({
  password: yup.string().trim().required("Vui lòng nhập mật khẩu"),
  confirm_password: yup
    .string()
    .trim()
    .required("Vui lòng xác nhận lại mật khẩu của bạn")
    .test(
      "empty",
      "Xác nhận mật khẩu không khớp",
      (
        confirm_password: string | undefined,
        testContext: yup.TestContext<yup.AnyObject>,
      ): boolean => {
        if (!testContext.parent.password) return true;
        return testContext.parent.password === confirm_password;
      },
    ),
});

const ChangePasswordWithdrawMobile = () => {
  const navigate = useNavigate();

  const username = useAppSelector(selectUsername);
  const profile = useAppSelector(selectProfile);

  const dispatch = useAppDispatch();

  const [isOpenDraw, setIsOpenDraw] = useState<boolean>(true);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<PasswordWithdrawType>({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const onSubmit = async (data: PasswordWithdrawType) => {
    try {
      const res = await UserApi.updateProfile(username, {
        username,
        withdraw_password: data.password,
      });

      const { msg, status } = res as ApiResponse;

      if (status !== ResponseCode.SUCCESS) {
        message.error({
          key: "changePassword-withdraw",
          content: msg,
        });
        return;
      }

      message.success({
        key: "changePassword-withdraw",
        content: msg,
      });
      dispatch(updateChangepassword(data.password));
      setIsOpenDraw(false);
      navigate("/user");
      reset();
    } catch (error) {
      console.log(error);
    }
  };

  const handleClose = () => {
    setIsOpenDraw(false);
    navigate(userPath);
  };

  return (
    <MDrawer
      title={"Thay đổi mật khẩu rút tiền"}
      isOpen={isOpenDraw}
      onClose={handleClose}
    >
      <div
        css={css`
          border: 1px solid #ddd;
          border-radius: 4px;
        `}
      >
        <div
          css={css`
            display: flex;
            flex-direction: column;
            border: 1px solid #ddd;
            border-radius: 3px;
          `}
        >
          <div
            css={css`
              background-color: #ffffff;
              padding: 15px 20px 30px;
              display: flex;
              flex-direction: column;
              gap: 20px;
            `}
          >
            {profile?.withdraw_password ? (
              <></>
            ) : (
              <div
                css={css`
                  display: flex;
                  padding: 16px;
                  gap: 4px;
                  align-items: center;
                  border-radius: 4px;
                  border: 1px solid #faebcc;
                  background-color: #fcf8e3;
                `}
              >
                <div
                  css={css`
                    height: 100%;

                    & .ant-image-img {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    }
                  `}
                >
                  <Image src={WarningIcon} alt="" height={14} width={14} />
                </div>
                <p
                  css={css`
                    font-size: 14px;
                    font-weight: 400;
                    font-family: Arial, Helvetica, sans-serif;
                    color: #8a6d3b;
                    text-align: center;
                  `}
                >
                  Mật khẩu rút tiền chưa cài đặt, vui lòng cài đặt mật khẩu rút
                  tiền trước
                </p>
              </div>
            )}

            <Form onSubmitCapture={handleSubmit(onSubmit)}>
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                `}
              >
                <div
                  css={css`
                    display: flex;
                    gap: 4px;
                    flex-direction: column;
                  `}
                >
                  <p
                    css={css`
                      font-size: 14px;
                      font-weight: 700;
                      width: 100%;
                    `}
                  >
                    Mật khẩu rút tiền
                  </p>

                  <InputCustom
                    type="password"
                    control={control}
                    name="password"
                    errors={errors.password?.message}
                    validate_status={errors.password ? "error" : "success"}
                    placeholder="Vui lòng nhập mật khẩu rút tiền của bạn"
                  />
                </div>

                <div
                  css={css`
                    display: flex;
                    gap: 4px;

                    flex-direction: column;
                  `}
                >
                  <p
                    css={css`
                      font-size: 14px;
                      font-weight: 700;
                      width: 100%;
                    `}
                  >
                    Xác nhận mật khẩu rút tiền
                  </p>

                  <InputCustom
                    control={control}
                    name="confirm_password"
                    type="password"
                    errors={errors.confirm_password?.message}
                    validate_status={
                      errors.confirm_password ? "error" : "success"
                    }
                    placeholder="Vui lòng xác nhận mật khẩu rút tiền của bạn"
                  />
                </div>
                <div
                  css={css`
                    display: flex;
                    gap: 15px;
                    justify-content: center;
                  `}
                >
                  <Button
                    css={css`
                      padding: 8px 15px;
                      height: 100%;

                      :hover {
                        border-color: #d9d9d9 !important;
                        color: black !important;
                      }
                    `}
                    htmlType="submit"
                  >
                    Gửi đi
                  </Button>
                  <Button
                    css={css`
                      padding: 8px 15px;
                      height: 100%;

                      :hover {
                        border-color: #d9d9d9 !important;
                        color: black !important;
                      }
                    `}
                    onClick={() => {
                      navigate("/");
                    }}
                  >
                    Huỷ bỏ
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </MDrawer>
  );
};

export default ChangePasswordWithdrawMobile;
